import LegalPage, { LList, EmailLink } from "@/components/LegalPage";

const SECTIONS = [
  {
    title: "1. Overview",
    body: (
      <p>
        This Refund &amp; Cancellation Policy explains how cancellations and
        refund requests are handled for paid Abhyas subscriptions. Please read
        it together with our Terms of Service.
      </p>
    ),
  },
  {
    title: "2. Subscription Cancellation",
    body: (
      <p>
        For cancellation assistance, please contact us at <EmailLink /> from
        your registered email address, and we will help you cancel your
        subscription.
      </p>
    ),
  },
  {
    title: "3. Refund Eligibility",
    body: (
      <>
        <p>
          A refund request may be considered if it is submitted within 7 days
          of the original subscription purchase, provided the subscription has
          not been materially used.
        </p>
        <p>
          "Materially used" generally means substantial consumption of the
          subscription's benefits — for example, generating a significant
          number of AI practice sessions or otherwise using a substantial
          portion of the plan's included features. Meeting these conditions
          does not guarantee that every request will qualify; each request is
          reviewed individually, subject to applicable consumer laws.
        </p>
      </>
    ),
  },
  {
    title: "4. Non-Refundable Circumstances",
    body: (
      <>
        <p>Refunds may generally not be available for:</p>
        <LList
          items={[
            "Requests made after the applicable refund window",
            "Subscription periods that have already been substantially used",
            "AI generations or benefits already consumed",
            "Promotional or discounted purchases where the applicable offer states otherwise",
            "Failure to cancel before an applicable renewal date",
            "Accounts suspended for serious violations of the Terms of Service",
          ]}
        />
        <p>
          Nothing in this section limits rights you may have under applicable
          consumer protection laws.
        </p>
      </>
    ),
  },
  {
    title: "5. Renewal and Cancellation",
    body: (
      <p>
        Cancelling a subscription generally prevents future renewals but does
        not necessarily create an automatic refund for the current billing
        period. Your access typically continues until the end of the period you
        have already paid for.
      </p>
    ),
  },
  {
    title: "6. How to Request a Refund",
    body: (
      <>
        <p>
          To request a refund, email us at <EmailLink /> and include:
        </p>
        <LList
          items={[
            "Your registered email address",
            "Your name",
            "Purchase date",
            "Subscription plan (Starter / Pro / Elite)",
            "Reason for the refund request",
            "Relevant payment/order reference, if available",
          ]}
        />
      </>
    ),
  },
  {
    title: "7. Refund Processing",
    body: (
      <p>
        Approved refunds will be initiated through the original payment method
        via the applicable payment processor. Actual processing time may depend
        on the payment provider and the banking system, and is outside
        Abhyas's direct control once initiated.
      </p>
    ),
  },
  {
    title: "8. Policy Changes",
    body: (
      <p>
        We may update this policy from time to time. The latest version will
        always be published on this page.
      </p>
    ),
  },
  {
    title: "9. Contact",
    body: (
      <p>
        For cancellation or refund assistance, contact us at <EmailLink />.
      </p>
    ),
  },
];

const RefundCancellation = () => (
  <LegalPage
    testid="refund-cancellation-page"
    title="Refund & Cancellation Policy"
    intro="This policy applies to paid Abhyas subscriptions (Starter, Pro, and Elite plans)."
    sections={SECTIONS}
  />
);

export default RefundCancellation;
